import { FlightCard } from '@/src/types/flight'

export const isFareFamilyEnabled = (flight: FlightCard) => {
    const fk = flight?.priceBreakup?.fare?.fk
    const isAMADEUS_INTERNATIONAL = fk?.includes('AMADEUS_INTERNATIONAL')
    const isAMADEUS = fk?.includes('AMADEUS')
    const fareFamilyEnabled = flight?.priceBreakup?.fare?.fareFamilyEnabled
    return fareFamilyEnabled || isAMADEUS_INTERNATIONAL || isAMADEUS
}
